import { BrandliveEvent } from '@/types/projects.types';
import { Delete } from '../helpers';

export const DeleteProject = (projectUuid: string): Promise<BrandliveEvent> => {
  return Delete({
    path: `/v3/admin/events/event/${projectUuid}`,
  });
};
